import React from "react";
import { resolveImage } from "../lib/api";

const WIDTHS = [640, 1024, 1600, 2400];
const DEFAULT_W = 1600;

function variantUrl(url, w) {
  if (url.includes("images.pexels.com")) {
    return `${url.split("?")[0]}?auto=compress&cs=tinysrgb&fm=webp&q=75&w=${w}`;
  }
  if (url.includes("images.unsplash.com")) {
    return `${url.split("?")[0]}?auto=format&fit=max&q=75&w=${w}`;
  }
  if (/\/api\/media\/[^/?]+\.(jpe?g|png|webp)$/i.test(url.split("?")[0])) {
    return `${url.split("?")[0]}?w=${w}`;
  }
  return null;
}

export function responsiveSources(raw) {
  const url = resolveImage(raw);
  if (!url || !variantUrl(url, DEFAULT_W)) return { src: url };
  return {
    src: variantUrl(url, DEFAULT_W),
    srcSet: WIDTHS.map((w) => `${variantUrl(url, w)} ${w}w`).join(", "),
  };
}

// <img> that lets the browser pick a right-sized, compressed variant
const ResponsiveImg = React.forwardRef(function ResponsiveImg({ src, sizes = "100vw", priority = false, ...rest }, ref) {
  const { src: s, srcSet } = responsiveSources(src);
  return (
    <img
      ref={ref}
      src={s}
      srcSet={srcSet}
      sizes={srcSet ? sizes : undefined}
      loading={priority ? "eager" : rest.loading || "lazy"}
      fetchPriority={priority ? "high" : undefined}
      decoding="async"
      {...rest}
    />
  );
});

export default ResponsiveImg;

export const SIZES = {
  card: "(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw",
  half: "(min-width: 768px) 50vw, 100vw",
  third: "(min-width: 768px) 33vw, 100vw",
  featured: "(min-width: 1024px) 58vw, 100vw",
  article: "(min-width: 1200px) 1200px, 100vw",
};
